import { useState, useContext } from 'react'
import { Drawer, Divider } from 'antd'
import { TiThMenu } from "react-icons/ti"
import { useNavigate } from 'react-router-dom'
import { MyContext } from '../App'

export function NavMenu() {

      const navigate = useNavigate()

      const { UserData } = useContext(MyContext)

      const [open, setOpen] = useState(false)
      const showDrawer = () => {
            setOpen(true)
      }
      const onClose = () => {
            setOpen(false)
      }

      return (

            <>
                  <TiThMenu className="clickable" onClick={showDrawer} style={{ color: 'rgba(0,0,0,0.6)', fontSize: '30px', marginTop: '10px' }} />

                  <Drawer className="nav-menu-drawer" title="MENU" placement="right" onClose={onClose} open={open}>

                        <div className="menu-link">

                              {/* Show to all logged in users */}
                              {UserData
                                    ? <>
                                          <p className="navgroup_title">Customers</p>
                                          <p className="navgroup_link" onClick={() => navigate('/reports/customers')}> - Recent</p>
                                          <p className="navgroup_link" onClick={() => navigate('/reports/tickets')}> - Sofia Tickets</p>

                                          <Divider />
                                          <p className="navgroup_title">Administration</p>
                                          <p className="navgroup_link" onClick={() => navigate('/reports/acturis')}>- Acturis Error Log</p>
                                          <p className="navgroup_link" onClick={() => navigate('/reports/accounting/reconciliation')}>- IBA & Payment Reconciliation</p>
                                          <p className="navgroup_link" onClick={() => navigate('/reports/accounting/opayo')}>- Opayo Reconciliation</p>
                                          <p className="navgroup_link" onClick={() => navigate('/reports/cbpf')}>- CBPF Reporting Suite</p>
                                    </>
                                    : null}

                              {/* Show to management only */}
                              {UserData?.isManagement === 1
                                    ? <>
                                          <Divider />
                                          <p className="navgroup_title">Management</p>
                                          <p className="navgroup_link" onClick={() => navigate('/management/users')}>- User Administration</p>
                                          <p className="navgroup_link" onClick={() => navigate('/reports/sales/performance-analysis')}>- Performance Analysis</p>
                                    </>
                                    : null}
                        </div>

                  </Drawer >
            </>

      )

}